import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ProfileSidebar from './components/ProfileSidebar';
import ProfileOrders from './components/ProfileOrders';
import ProfileBonus from './components/ProfileBonus';
import ProfileFavorites from './components/ProfileFavorites';
import ProfileSettings from './components/ProfileSettings';
import ProfilePromoCodes from './components/ProfilePromoCodes';
import ProfileSavedPromos from './components/ProfileSavedPromos';
import ProfileRecentlyViewed from './components/ProfileRecentlyViewed';
import SeoHead from '@/components/feature/SeoHead';

type Tab = 'orders' | 'bonus' | 'favorites' | 'settings' | 'promocodes' | 'savedpromos' | 'history';

const ProfilePage = () => {
  const [activeTab, setActiveTab] = useState<Tab>('orders');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title="Личный кабинет — NeonPharma"
        description="Личный кабинет NeonPharma: заказы, бонусы, избранное, настройки профиля."
        noIndex={true}
      />
      <Navbar />

      {/* Header */}
      <section className="pt-28 pb-8 px-4 md:px-8 lg:px-12 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-80 h-64 opacity-8 rounded-full" style={{ background: '#f0ff00', filter: 'blur(100px)' }} />
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="flex items-center gap-2 font-mono text-xs text-white/30 mb-4">
            <Link to="/" className="hover:text-white/60 transition-colors">Главная</Link>
            <i className="ri-arrow-right-s-line" />
            <span style={{ color: '#f0ff00' }}>Личный кабинет</span>
          </div>
          <h1 className="font-orbitron font-black text-3xl md:text-4xl text-white">
            ЛИЧНЫЙ <span style={{ color: '#f0ff00', textShadow: '0 0 20px rgba(240,255,0,0.4)' }}>КАБИНЕТ</span>
          </h1>
        </div>
      </section>

      {/* Main content */}
      <section className="pb-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-6 items-start">
          <ProfileSidebar activeTab={activeTab} onTabChange={(tab) => setActiveTab(tab as Tab)} />
          <div className="flex-1 min-w-0">
            {activeTab === 'orders' && <ProfileOrders />}
            {activeTab === 'bonus' && <ProfileBonus />}
            {activeTab === 'favorites' && <ProfileFavorites />}
            {activeTab === 'settings' && <ProfileSettings />}
            {activeTab === 'promocodes' && <ProfilePromoCodes />}
            {activeTab === 'savedpromos' && <ProfileSavedPromos />}
            {activeTab === 'history' && <ProfileRecentlyViewed />}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProfilePage;
